import React from 'react';

export function Competencies() {
  return (
    <section className="section">
    <h1 className="about" style={{marginLeft:100}}>Language:</h1>
    <div className="auText" type="text">
    <p style={{ marginLeft: '90px'}}>
        <span style={{ marginRight: '10px' }}>❖</span>
         Swedish - Fluent
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         English - Fluent
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         Arabic - Native
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         Frensh - Basic Knowledge
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         Kurdish - Basic Knowledge
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         Turkish - Basic Knowledge
         <br></br>
        </p>
        </div>
        <h1 className="about" style={{marginLeft:100}}>Computer Skills:</h1>
        <div className="auText" type="text">
        <p style={{ marginLeft: '90px'}}>
        <span style={{ marginRight: '10px' }}>❖</span>
         Microsoft Office Package - Proficient
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         Hardware Skills - Proficient
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         Linux - Proficient
         <br></br>
            </p>
            </div>
            <h1 className="about" style={{marginLeft:100}}>Programming Language:</h1>
        <div className="auText" type="text">
        <p style={{ marginLeft: '90px'}}>
        <span style={{ marginRight: '10px' }}>❖</span>
         Java
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         Python
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         C
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         Javascript
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         HTML
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         CSS
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         Prolog
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         Assembly
         <br></br>
            </p>
            </div>
    </section>
  )
}